import styled from "@emotion/styled";
import React from "react";
import UI from "@mile-meeting/mile-ui";
import WarningModal from "pages/meeting/MeetingRoomManage/MeetingRoomManagement/warning-modal";

interface GoogleOptionFieldProps {
  enablePrivateRoom: boolean;
  onChange: (value: boolean) => void;
  onDisconnect: () => void;
  roomName?: string;
}

const GoogleOptionField: React.FC<GoogleOptionFieldProps> = ({
  enablePrivateRoom,
  onChange,
  onDisconnect,
  roomName,
}) => {
  const [openGoogleDisconnectModal, setOpenGoogleDisconnectModal] = React.useState(false);

  return (
    <GoogleSettingContainer>
      <UI.Typography type="label01" fontStyle="bold" color="var(--alias-color-label-alternative)">
        Google Workspace 리소스 캘린더
      </UI.Typography>
      <GoogleSettingItemList>
        <GoogleSettingItemContainer>
          <div style={{ display: "flex", gap: "4px", alignItems: "center" }}>
            <UI.Icon name="google" size={20} />
            <UI.Typography type="body01 normal" fontStyle="medium" color="var(--alias-color-label-normal)">
              {roomName}
            </UI.Typography>
          </div>
          <UI.Button
            type="outlined"
            title="연동 해제"
            size="small"
            primary={false}
            onClick={() => setOpenGoogleDisconnectModal(true)}
          />
        </GoogleSettingItemContainer>
        <GoogleSettingItemContainer>
          <div style={{ display: "flex", gap: "4px", alignItems: "center" }}>
            <UI.Icon name="eyeClosed" size={20} color="var(--alias-color-label-normal)" />
            <UI.Typography type="body01 normal" fontStyle="medium" color="var(--alias-color-label-normal)">
              비공개 회의 데이터 수집 및 조회
            </UI.Typography>

            <UI.ToolTip
              position={{
                top: 24,
                left: -235,
              }}
              type="default"
              text={
                <p>
                  비활성화 시 비공개 회의에 한해, 회의 제목/내용/예약자 및 참석자를 저장하지 않습니다.
                  <br />
                  (단, 회의실 예약에 필수적인 일정과 회의 정보는 저장됩니다.)
                </p>
              }
            >
              <UI.Icon name="info" size={20} color="var(--alias-color-label-assistive)" />
            </UI.ToolTip>
          </div>
          <UI.Selection.Toggle.Default
            size="medium"
            state={enablePrivateRoom}
            onChange={() => {
              onChange(!enablePrivateRoom);
            }}
          />
        </GoogleSettingItemContainer>
      </GoogleSettingItemList>
      <WarningModal
        modalIsOpen={openGoogleDisconnectModal}
        closeModal={() => {
          setOpenGoogleDisconnectModal(false);
        }}
        title={`"${roomName}"의 리소스 캘린더 연동을 해제하시겠습니까?`}
        content="연동이 해제되면 일정 동기화가 중단됩니다."
        onChange={() => {
          onDisconnect();
          setOpenGoogleDisconnectModal(false);
        }}
      />
    </GoogleSettingContainer>
  );
};

export default React.memo(GoogleOptionField);

const GoogleSettingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
`;

const GoogleSettingItemList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;

const GoogleSettingItemContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;
